import React, { useEffect } from 'react';
import { AlertCircle, Check, X } from 'lucide-react';

const ModernConfirmationPopup = ({ isOpen, onClose, onConfirm, message }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modern-confirm-overlay">
      <div className="modern-confirm-container">
        <button className="modern-confirm-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="modern-confirm-icon">
          <AlertCircle size={48} className="warning-icon" />
        </div>

        <h3 className="modern-confirm-title">
          Confirm Submission
        </h3>

        <div className="modern-confirm-content">
          <p className="modern-confirm-message">{message}</p>
        </div>

        <div className="modern-confirm-buttons">
          <button type="button" className="modern-confirm-cancel" onClick={onClose}>
            <X size={18} />
            Cancel
          </button>
          <button type="button" className="modern-confirm-submit" onClick={onConfirm}>
            <Check size={18} />
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModernConfirmationPopup;